import { render, staticRenderFns } from "./Teleplay.vue?vue&type=template&id=0d2d18fa"
import script from "./Teleplay.vue?vue&type=script&lang=js"
export * from "./Teleplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports